export default __webpack_public_path__ + "static/media/howTo2.db9c974c.svg";